import React from 'react'

import HubSpotIcon from '../../components/AppIcon/HubSpotIcon'

function AppLinkSection({ application, setIsHovering = null }) {
  return (
    <ul
      className='h-20 w-40 flex flex-col justify-around px-2 bg-white absolute -right-5 -top-3 shadow-lg border rounded'
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <li>
        {application?.hubspotContactId ? (
          <a
            target='_blank'
            rel='noopener noreferrer'
            href={`https://app.hubspot.com/contacts/47305776/record/0-1/${application?.hubspotContactId}`}
            title="HubSpot"
          >
            <HubSpotIcon className='w-28 ml-1 hover:opacity-60' />
          </a>
        ) : (
          <div title='Disabled'>
            <HubSpotIcon className='w-28 ml-1 opacity-30' />
          </div>
        )}
      </li>
    </ul>
  )
}

export default AppLinkSection
